import { Component, OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { AdsService } from '../Services/ads.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { CookieService } from '../Services/cookie';
import { browserRefresh } from '../app.component';
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: "app-landing-page-my-favourites",
  templateUrl: "./landing-page-my-favourites.component.html",
  standalone:false,
  styleUrls: ["./landing-page-my-favourites.component.scss"],
})
export class LandingPageMyFavouritesComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  FavouriteOffers: any[];

  constructor(private router: Router, private Ads: AdsService,public translate: TranslateService, private common: CommonService,    private cookieService: CookieService,
    public auth:AuthService) {}
  activeTab: number;
  disabled;
  heartfunction:boolean = false;
  public browserRefresh: boolean;

  
 async  ngOnInit(): Promise<any> {


  this.browserRefresh = browserRefresh;

  console.log('refreshed?:', browserRefresh);


  this.common.presentLoading();
  this.auth.accessToken = await this.common.Get("token");

  await  this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {  

    if (data?.response) {
      if (data?.response?.code) {
        if (data?.response?.code == 1) {

   
          //  this.cookieService.set("detailuser",JSON.stringify(data.response.content.allowedServices),false,undefined,undefined,undefined,undefined,true,"Strict")
          this.Ads.GetFavouriteOffersPaginated(1,this.auth.accessToken).then((data: any) => {

            if (data?.response.code == 1) {
              if(this.auth.detailuser != undefined){
                let F = [...data.response.content.data]
                F.forEach(element => {
                  element['heart']= true;
                  
                });
                this.FavouriteOffers = data.response.content.data;
                if(this.FavouriteOffers.length == 0){
                  // this.common.ParseErrorAlert('', 'OK', this.router, "No Favourite Offers to show")
                   this.common.parseError('NO_FAV_OFFERS').then((msg: string) => {
                   this.common.ParseErrorAlert(
                   '',
                   this.translate.instant('OK'),
                   this.router,
                   msg
                   );
                   });
  
                }
                console.log('GetFavouriteOffersPaginated', this.FavouriteOffers)
              }
              else{
                this.FavouriteOffers = [];
              }
             
              this.common.hideLoading();
  
            }
            else {
              this.common.hideLoading();
              this.common.ParseErrorAlert('', 'OK', this.router, data)
            }
          })
          // this.common.hideLoading();

        

        } else {
          await this.common.hideLoading();
          this.common.ParseErrorAlert("", "", this.router, data);
        }
      } else {
        await this.common.hideLoading();
        this.common.ParseErrorAlert("", "", this.router, data);
      }
    } else {
      await this.common.hideLoading();
      this.common.ParseErrorAlert("", "", this.router, data);
    }
  });

 

    
  }
  showModal(num) {
    this.modalObservable.next(num);
  }
  loginWithIdNum() {
    this.router.navigateByUrl("/LoginWithIdNum");
  }
  landingPageOfferDetails(id) {
    if(this.heartfunction == false ){

      this.cookieService.set("offerid",id,true);   
       this.router.navigateByUrl("/LandingPageOfferDetails");
    }
    
  }
  changeTab(e) {
    this.activeTab = e;
  }

  async heartIcon(id,i) {

    this.heartfunction = true;
    this.common.presentLoading();
    await this.Ads.SaveFavourite(id, this.auth.accessToken).then((res: any) => {

      if (res?.response?.code == 1) {

        this.FavouriteOffers[i].heart = false;     
  
        this.FavouriteOffers.splice(i,1);

        this.heartfunction = false;
        console.log('FavouriteOffersaved')
        this.common.hideLoading();
      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert('', "OK", this.router, res);
      }
    });

  }

  async logOut() {}
}
